import { useEffect, useState } from 'react';

// Global imperative toast. Components can call `toast("message")` from anywhere.
export function toast(message) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('app:toast', { detail: { message } }));
}

// Optional: attach to window so legacy ported code that calls window.toast still works.
if (typeof window !== 'undefined' && !window.toast) {
  window.toast = toast;
}

export function ToastHost() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const onToast = (e) => {
      const id = Math.random().toString(36).slice(2);
      const message = e.detail?.message ?? '';
      setItems((cur) => [...cur, { id, message }]);
      setTimeout(() => {
        setItems((cur) => cur.filter((t) => t.id !== id));
      }, 2500);
    };
    window.addEventListener('app:toast', onToast);
    return () => window.removeEventListener('app:toast', onToast);
  }, []);

  return (
    <div className="toast-host">
      {items.map((t) => (
        <div key={t.id} className="toast">
          {t.message}
        </div>
      ))}
    </div>
  );
}
